import { useMemo, useState } from "react";
import { galleryImages, galleryTags } from "@/mocks/resources";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Gallery() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () =>
      active === "全部"
        ? galleryImages
        : galleryImages.filter((img) => img.tag === active),
    [active],
  );

  return (
    <section id="gallery" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="图片专题"
          icon="ri-image-2-line"
          title="色虎图片资源 · 主题图集筛选"
          desc="图片资源以单张摄影作品为单位整理，覆盖自然风光、人文纪实、城市影像、旅行记录与生活美学等主题。使用下方标签可在本页范围内即时筛选，只显示已收录的相关图片。"
        />

        <div className="mb-4 flex flex-wrap gap-2" role="tablist" aria-label="图片主题筛选">
          {galleryTags.map((tag) => (
            <button
              key={tag}
              type="button"
              role="tab"
              aria-selected={active === tag}
              onClick={() => setActive(tag)}
              className={`px-4 py-2 rounded-full text-sm border transition-colors cursor-pointer whitespace-nowrap ${
                active === tag
                  ? "bg-secondary-600 border-secondary-600 text-background-50 font-medium"
                  : "bg-background-50 border-background-300 text-foreground-700 hover:border-secondary-300 hover:text-secondary-800"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <p className="mb-6 text-xs md:text-sm text-foreground-500">
          当前分类共 <span className="font-semibold text-foreground-900">{list.length}</span> 张图片
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {list.map((img) => (
            <figure
              key={img.id}
              className="group relative rounded-lg overflow-hidden bg-foreground-900 aspect-square cursor-pointer"
            >
              <img
                src={img.cover}
                alt={`色虎图片资源：${img.title}`}
                title={`${img.title} 在线观看`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <figcaption className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-transparent to-transparent opacity-90">
                <div className="absolute inset-x-0 bottom-0 p-3">
                  <span className="text-[11px] px-2 py-0.5 rounded-full bg-accent-500 text-background-50">
                    {img.tag}
                  </span>
                  <p className="mt-2 text-sm font-medium text-background-50">{img.title}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}